// Components
import { DateInput } from "components"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

// Types
import type { FormType } from "../utils"

export function TransactionDate(): JSX.Element {
  // Form
  const { control } = useFormContext<FormType>()

  return (
    <Controller
      name="transaction_date"
      control={control}
      render={({ field, fieldState }) => (
        <DateInput
          label="RECEIVE DATE"
          error={fieldState.error?.message}
          selected={moment(field.value).toDate()}
          ref={field.ref}
          onChange={(date) => {
            // Vars
            const selectedDate = moment(date).format("YYYY-MM-DD")

            field.onChange(selectedDate)
          }}
        />
      )}
    />
  )
}